import React, { useState } from 'react'
import { useTrans } from 'hooks'
import { CategoriaNode, PaginaNode } from '@gql/graphql'
import {
  Page,
  PluspointSection,
  ProdottiCorrelati,
  TabellaCompatibilitaVolantiniModal,
  TextImageLarge,
} from 'components/organisms'
import styles from './SottoCategoriaVolantiniTemplate.module.sass'
import { Button, EditableTitle, WContainer } from '@components/atoms'
import { ArrowLeft, Download } from '@components/icons'
import { TabellaVolantini } from '@components/molecules'

interface Props {
  pagina?: PaginaNode
  sottoCategoria: CategoriaNode
}

const SottoCategoriaVolantiniTemplate = (props: Props) => {
  const { pagina = undefined, sottoCategoria } = props
  const [isTabellaCompatibilitaVisible, setTabellaCompatibilitaVisible] = useState(false)

  const t = useTrans()

  const handleTabellaCompatibilitaOpen = () => {
    if (!sottoCategoria?.tabellaCompatibilita) return
    setTabellaCompatibilitaVisible(true)
  }
  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <WContainer>
          <div className={styles.back}>
            <Button
              label={`${t('Torna alla')} ${sottoCategoria.volantinoVisualizzato.titolo}`}
              variant="ghost"
              iconLeft={<ArrowLeft />}
              href={'../'}
            />
          </div>
        </WContainer>

        <TextImageLarge
          item={{
            name: sottoCategoria.nome,
            description: sottoCategoria.descrizioneVolantino,
            image: sottoCategoria.immagineVolantino,
          }}
          volantini={true}
          imagePos="right"
        />

        {sottoCategoria?.plusPoints?.length > 0 && (
          <PluspointSection plusPoints={sottoCategoria.plusPoints} />
        )}

        <TabellaVolantini tabellaDatiTecnici={sottoCategoria.tabellaDatiTecnici} />
        <ProdottiCorrelati
          titolo={t('Spesso acquistati insieme')}
          prodotti={sottoCategoria.accessoriCompatibili}
        />

        <div className={styles.ctaSection}>
          <Button
            size="lg"
            variant="secondary"
            label={t('vedi tabella di compatibilità')}
            onClick={handleTabellaCompatibilitaOpen}
          />
        </div>

        <TextImageLarge
          item={{
            intro: sottoCategoria.volantinoVisualizzato.intro,
            name: sottoCategoria.volantinoVisualizzato.titolo,
            description: sottoCategoria.volantinoVisualizzato.descrizione,
            image: sottoCategoria.volantinoVisualizzato.immagine,
          }}
          theme="secondarydark"
        />
        {sottoCategoria.volantinoVisualizzato.pdfUrl && (
          <Button
            label={t('Scarica il volantino')}
            iconRight={<Download />}
            className={styles.downloadButtonDesk}
            href={sottoCategoria.volantinoVisualizzato.pdfUrl}
          />
        )}
        <div className={styles.downloadVolatinoMobileSection}>
          <WContainer>
            <EditableTitle
              title={t('Vuoi stampare questo volantino?')}
              className={styles.downloadTitle}
            />
            {sottoCategoria.volantinoVisualizzato.pdfUrl && (
              <Button
                label={t('Scarica il volantino in PDF')}
                variant="secondary"
                iconRight={<Download />}
                className={styles.downloadButtonMobile}
                href={sottoCategoria.volantinoVisualizzato.pdfUrl}
              />
            )}
          </WContainer>
        </div>

        <TabellaCompatibilitaVolantiniModal
          id={`sottocategoria-compatibilità-${sottoCategoria.slug}`}
          open={isTabellaCompatibilitaVisible}
          onClose={() => setTabellaCompatibilitaVisible(false)}
          sottoCategoria={sottoCategoria}
        />
      </main>
    </Page>
  )
}

export default SottoCategoriaVolantiniTemplate
